import React from 'react';
import Column from '@amzn/meridian/column';
import { css } from 'emotion';
import wallpaper from '../images/carrierLogisticsBackgroundImg.png';
import '../styles/index.css';
import WallpaperContentBlock from '../components/homePage/WallpaperContentBlock';
import SplashScreen from '../components/Splashscreen';
import WallpaperContent from '../components/homePage/WallpaperContent';
import FrequentlyAskedQuestions from '../components/homePage/FrequentlyAskedQuestions';
import WhyAmazonContentBlock from '../components/homePage/WhyAmazonContentBlock';
import { CONTAINER_SIZE_IN_PX } from '../constants/externalPassportUIConstants';
import useUserSession from '../hooks/useUserSession';

const HomePage = () => {
  const { isUserSessionLoading } = useUserSession();
  return isUserSessionLoading ? (
    <SplashScreen />
  ) : (
    <div
      className={css`
        max-width: ${CONTAINER_SIZE_IN_PX};
        margin: auto;
        position: relative;
      `}
    >
      <Column
        alignmentHorizontal="center"
        spacingInset="none"
        spacing="none"
        backgroundColor="#055D7B"
      >
        <img
          className={css`
            width: 100%;
            max-height: 40rem;
          `}
          src={wallpaper}
          alt="Logo"
        />
        <WallpaperContentBlock />
      </Column>
      <Column alignmentHorizontal="center" spacingInset="none" spacing="none">
        <WhyAmazonContentBlock />
        <WallpaperContent />
      </Column>
      <Column alignmentHorizontal="center">
        <FrequentlyAskedQuestions />
      </Column>
    </div>
  );
};
export default HomePage;
